// extracted by mini-css-extract-plugin
export default {"section":"mainhero_section__ERraQ","second":"mainhero_second__TYBfb"};